import { Namespace, TranslationKey } from "@racoon/i18n";
import { JOB_STATUS_TONE, STATUS_TONE_CLASS } from "./status-palette";

export const enumColors: Partial<
  Record<TranslationKey<Namespace.Enum>, { bg: string; color: string; borderColor?: string }>
> = {
  USER_ROLE_UNDEFINED: { bg: "bg-gray-200", color: "text-gray-600" },
  USER_ROLE_ADMIN: { bg: "bg-brand-blue", color: "text-white" },
  USER_ROLE_RECEIVER_USER: { bg: "bg-brand-green-light", color: "text-brand-green" },
  USER_ROLE_DRIVER: { bg: "bg-brand-yellow-light", color: "text-brand-yellow" },
  USER_ROLE_PROVIDER_DISPATCHER: { bg: "bg-brand-purple-light", color: "text-brand-purple" },
  USER_ROLE_SUPPORT: { bg: "bg-brand-blue-light", color: "text-brand-blue" },
  USER_ROLE_PROVIDER_OWNER: { bg: "bg-brand-indigo", color: "text-white" },
  USER_ROLE_DISPOSAL_SITE_OWNER: { bg: "bg-brand-teal", color: "text-white" },
  USER_ROLE_GOVERNMENT_AUDITOR: { bg: "bg-brand-red-light", color: "text-brand-red" },
  USER_ROLE_GOVERNMENT_AUDITOR_EDITOR: { bg: "bg-brand-red", color: "text-white" },
  USER_ROLE_PROVIDER_MECHANIC: { bg: "bg-brand-orange-light", color: "text-brand-orange" },
  USER_ROLE_GPS_INNER_SERVICE: { bg: "bg-gray-300", color: "text-gray-700" },
  USER_ROLE_PROVIDER_OWNER_VIEW_ONLY: { bg: "bg-brand-indigo-light", color: "text-brand-indigo" },
  // Outlined badges: the label takes the colour of the outline around it.
  PICKUP_LOCATION_PRIORITY_HIGH: {
    bg: "",
    color: "text-brand-red",
    borderColor: "border-brand-red",
  },
  PICKUP_LOCATION_PRIORITY_MEDIUM: {
    bg: "",
    color: "text-orange-500",
    borderColor: "border-orange-500",
  },
  PICKUP_LOCATION_PRIORITY_LOW: {
    bg: "",
    color: "text-brand-green",
    borderColor: "border-brand-green",
  },
  ORGANIZATION_STATUS_UNDEFINED: { bg: "", color: "" },
  ORGANIZATION_STATUS_INACTIVE: { bg: "", color: "" },
  ORGANIZATION_STATUS_ACTIVE: { bg: "", color: "" },
  UNRECOGNIZED: { bg: "", color: "" },
  ALL: { bg: "", color: "" },
  ACTIVE: { bg: "", color: "" },
  ARCHIVED: { bg: "", color: "" },
  TRUCK_TYPE_CONSTRUCTION: { bg: "", color: "" },
  PICKUP_LOCATION_TYPE_CONSTRUCTION: { bg: "", color: "" },
  TRUCK_STATUS_ACTIVE: {
    bg: "bg-text-invert",
    color: "text-text-secondary",
    borderColor: "border-text-invert",
  },
  TRUCK_STATUS_INACTIVE: {
    bg: "bg-brand-red",
    color: "text-white",
  },
  TRUCK_STATUS_NO_SHIFT: {
    bg: "bg-brand-red-light",
    color: "text-brand-red",
  },
  TRUCK_STATUS_IN_REPAIR: { bg: "bg-brand-yellow", color: "text-primary" },
  TRUCK_STATUS_ON_LINE: {
    bg: "bg-accent-green",
    color: "text-white",
  },
  TRUCK_ON_WAY: { bg: "bg-brand-blue", color: "text-white" },
  TRUCK_WAITING: { bg: "bg-brand-blue-light", color: "text-brand-blue" },
  ...Object.fromEntries(
    Object.entries(JOB_STATUS_TONE).map(([status, tone]) => [status, STATUS_TONE_CLASS[tone]]),
  ),
  JOB_TYPE_ADD_BUNKER: { bg: "bg-brand-blue", color: "text-white" },
  JOB_TYPE_REMOVE_BUNKER: { bg: "bg-brand-blue", color: "text-white" },
  JOB_TYPE_REPLACE_BUNKER: { bg: "bg-brand-blue", color: "text-white" },
  JOB_TYPE_UNDEFINED: { bg: "bg-brand-blue", color: "text-white" },
  RECEIVER_NOTIFIED: { bg: "bg-status-green", color: "text-brand-green" },
  RECEIVER_NOT_NOTIFIED: { bg: "bg-status-red", color: "text-brand-red" },
  LOCATION_STATUS_ACTIVE: { bg: "bg-brand-green", color: "text-white" },
  LOCATION_STATUS_INACTIVE: { bg: "bg-gray-200", color: "text-gray-600" },
  LOCATION_STATUS_UNDEFINED: { bg: "bg-gray-100", color: "text-gray-400" },
  TRUCK_STATUS_ENDED_SHIFT: { bg: "!bg-surface-brand", color: "text-white" },
  TRUCK_STATUS_NOT_APPROVED: { bg: "!bg-brand-blue-light", color: "!text-brand-blue" },
};
